import API from './api'

const {REACT_APP_API_URI} = process.env;

const updateProperty = (subject, keyProperty, valueProperty, collection, defaultValue) => {
    if(typeof defaultValue == "undefined") {
        defaultValue = null;
    }
    const key = subject[keyProperty];
    if(key && collection[key]) {
        subject[valueProperty] = collection[key]
    } else {
        subject[valueProperty] = defaultValue;
    }
    return subject
}

const formatEvents = (response) => {
    try {
        // Check if events exists and is an object or array
        const eventsData = response.data.data.events;
        if (!eventsData) {
            return [];
        }
        
        // Handle both object and array responses
        let events = Array.isArray(eventsData) ? eventsData : Object.values(eventsData);
        const users = response.data.data.users || {};
        const images = response.data.data.images || {};
        const locations = response.data.data.locations || {};
        const organizations = response.data.data.organizations || {};
        const categories = response.data.data.categories || {};
        
        return events.map((event) => {
            event = updateProperty(event, "created_by", "created_by", users);
            event = updateProperty(event, "updated_by", "updated_by", users);
            event = updateProperty(event, "deleted_by", "deleted_by", users);
            event = updateProperty(event, "location_id", "location", locations);
            event = updateProperty(event, "organization_id", "organization", organizations);
            event = updateProperty(event, "category_id", "category", categories);
            event = updateProperty(event, "profile_image_id", "profile_image", images);
            event = updateProperty(event, "card_image_id", "card_image", images);
            return event;
        });
    } catch (error) {
        console.error('Error formatting events:', error, response);
        return [];
    }
}

class AdminResourcesEventsApi {
    constructor(token) {
        this.api = new API(token);
        this.baseUrl = `${REACT_APP_API_URI}/admin/event`
    }

    all(status, pageNumber) {
        try {
            const page = pageNumber || 1;
            // Handle "All" status - omit it from query if it's "All"
            const statusParam = status === 'All' ? '' : `status=${status}&`;
            const url = `${this.baseUrl}?${statusParam}page_num=${page}`;
            
            return this.api.get(url)
            .then((response) => {
                const formattedEvents = formatEvents(response);
                return {
                    events: formattedEvents,
                    total_pages: response.data.data?.total_pages || 0,
                }
            })
            .catch((error) => {
                console.error('Error in all() method:', error);
                return {
                    events: [],
                    total_pages: 0,
                }
            });
        }catch(error) {
            console.error('Error in all() method (outer catch):', error);
            return {
                events: [],
                total_pages: 0,
            }
        }
    }

    search(search, status, pageNumber) {
        try {
            const page = pageNumber || 1;
            // Handle "All" status - omit it from query if it's "All"
            const statusParam = status === 'All' ? '' : `status=${status}&`;
            const url = `${this.baseUrl}?title=${search}&${statusParam}page_num=${page}`;
            
            return this.api.get(url)
            .then((response) => {
                const formattedEvents = formatEvents(response);
                return {
                    events: formattedEvents,
                    total_pages: response.data.data?.total_pages || 0,
                }
            })
            .catch((error) => {
                console.error('Error in search() method:', error);
                return {
                    events: [],
                    total_pages: 0,
                }
            });
        }catch(error) {
            console.error('Error in search() method (outer catch):', error);
            return {
                events: [],
                total_pages: 0,
            }
        }
    }

    searchByCity(searchCity, status, pageNumber) {
        try {
            const page = pageNumber || 1;
            // Handle "All" status - omit it from query if it's "All"
            const statusParam = status === 'All' ? '' : `status=${status}&`;
            const url = `${this.baseUrl}?city=${searchCity}&${statusParam}page_num=${page}`;
            
            return this.api.get(url)
            .then((response) => {
                const formattedEvents = formatEvents(response);
                return {
                    events: formattedEvents,
                    total_pages: response.data.data?.total_pages || 0
                }
            })
            .catch((error) => {
                console.error('Error in searchByCity() method:', error);
                return {
                    events: [],
                    total_pages: 0,
                }
            });
        }catch(error) {
            console.error('Error in searchByCity() method (outer catch):', error);
            return {
                events: [],
                total_pages: 0,
            }
        }
    }

    filterByLetter(status, value, pageNumber) {
        try {
            let letter = value.toLowerCase()
            const page = pageNumber || 1;
            // Handle "All" status - omit it from query if it's "All"
            const statusParam = status === 'All' ? '' : `status=${status}&`;
            const url = `${this.baseUrl}?${statusParam}title_start=${letter}&page_num=${page}`;
            
            return this.api.get(url)
                .then((response) => {
                    const formattedEvents = formatEvents(response);
                    return {
                        events: formattedEvents,
                        total_pages: response.data.data?.total_pages || 0
                    }
                })
                .catch((error) => {
                    console.error('Error in filterByLetter() method:', error);
                    return {
                        events: [],
                        total_pages: 0,
                    }
                });
        } catch (error) {
            console.error('Error in filterByLetter() method (outer catch):', error);
            return {
                events: [],
                total_pages: 0,
            }
        }
    }

    searchByNetwork(tenantId, status, pageNumber) {
        try {
            const page = pageNumber || 1;
            // Handle "All" status - omit it from query if it's "All"
            const statusParam = status === 'All' ? '' : `status=${status}&`;
            const url = `${this.baseUrl}?tenant_id=${tenantId}&${statusParam}page_num=${page}`;
            
            return this.api.get(url)
                .then((response) => {
                    const formattedEvents = formatEvents(response);
                    return {
                        events: formattedEvents,
                        total_pages: response.data.data?.total_pages || 0,
                    }
                })
                .catch((error) => {
                    console.error('Error in searchByNetwork() method:', error);
                    return {
                        events: [],
                        total_pages: 0,
                    }
                });
        }catch(error) {
            console.error('Error in searchByNetwork() method (outer catch):', error);
            return {
                events: [],
                total_pages: 0,
            }
        }
    }

    getById(id) {
        try {
            return this.api.get(`${this.baseUrl}/${id}`)
            .then((response) => {
                return formatEvents(response);
            });
        } catch(error) {
            console.error(`Error fetching event. id=${id}, error=${error}`);
            return {}
        }
    }

    delete(id) {
        try{
            return this.api.delete(`${this.baseUrl}/${id}`)
            .then((response) => {
                return response.data.data;
            });
        }catch(error) {
            console.error(`Error deleting event. error=${error}`);
            return {}
        }
    }
}

export default AdminResourcesEventsApi;
